import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import MainMenu from './components/pages/MainMenu';
import DesignerSection from './components/pages/DesignerSection';
import Gallery from './components/pages/Gallery';
import Constructor from './components/pages/Constructor';
import Collection from './components/pages/Collection';
import Info from './components/pages/Info';
import Loft1 from './components/pages/Loft1';
import Lotus from './components/pages/Lotus';
import Classic from './components/pages/Classic';
import Minimalism from './components/pages/Minimalism';
import Loft2 from './components/pages/Loft2';
import Footer from './components/Footer';
import { LanguageProvider } from './components/common/LanguageContext';
import './App.css';

function AppContent({ isMenuOpen, setIsMenuOpen }) {
  const location = useLocation();

  useEffect(() => {
    // Закрываем меню при изменении маршрута
    setIsMenuOpen(false);
  }, [location, setIsMenuOpen]);

  return (
    <div className="min-h-screen bg-[#F0EEEA]">
      <LanguageProvider>
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      {/* Затемняющий фон */}
      {isMenuOpen && <div className="overlay active"></div>}
      <div className={`app-content ${isMenuOpen ? 'dimmed' : ''}`}>
        <Routes>
          <Route path="/" element={<MainMenu isMenuOpen={isMenuOpen} />} />
          <Route path="/collection" element={/*<Collection /> должна была быть эта страница, но переработаная, поэтому стоит заглушка*/ <Constructor />} />
          <Route path="/collectionInDevelopment" element={<Collection /> /*Для отладки, если вдруг нужно будет посмотреть*/} />
          <Route path="/designers" element={<DesignerSection />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/constructor" element={<Constructor />} />
          <Route path="/info" element={<Info />} />
          <Route path="/models/loft1" element={<Loft1 />} />
          <Route path="/models/lotus" element={<Lotus />} />
          <Route path="/models/classic" element={<Classic />} />
          <Route path="/models/minimalism" element={<Minimalism />} />
          <Route path="/models/info2" element={<Loft2 />} />
        </Routes>
        <Footer />
      </div>
      </LanguageProvider>
    </div>
  );
}

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Router>
      <AppContent isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
    </Router>
  );
}

export default App;
